/* Built In Imports */
import NextLink from 'next/link';
import { useState, useEffect } from 'react';

/* External Imports */
import { Box, Link, SimpleGrid, Flex,  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
// import StructuredTextContent from '@components/UI/StructuredTextContent';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain, refreshPage } from '@components/Utility/utils';
import { Styles } from '../../constants';
import { TbPlayerPlayFilled } from 'react-icons/tb';
import { getEmbedUrl } from '@app-ihs/components/Utility/utils';
import dynamic from 'next/dynamic';
/* Services */

/**
 * Renders the Card Info 3 Card component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @param isLeftMenu - responsive navbar for the page
 * @returns {ReactElement} Card Info 3 Card component
 */

const CardInfo3V2 = ({ sectionContent, region, lang, isLeftMenu, pageConfig }) => {
  // const bgColors = ['#cd6727', '#ae4511', '#10069f'];
  const bgColors = Styles.bgColors;
  const pName = pageConfig?.pageName;
  const YouTube = dynamic(() => import('react-youtube'));
  const [opts, setOpts] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  // console.log("the page name is", pName)

  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight,
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global.window]); 

  const onReady = event => {
    event.target.playVideo();
  };
  return (
    <Box
      mx="auto"
      maxW={{
        base: '302px',
        sm: '480px',
        md: '690px',
        lg: '770px',
        xl: '1170px',
      }}
    >
      <SimpleGrid
        gridRowGap={{ base: '15px', lg: '60px' }}
        columns={{
          base: 1,
          md: pName === "hytt" ? 1 : 2,
          lg: isLeftMenu ? 3 : pName === "hytt" ? 1 : 2,
          xl: isLeftMenu
            ? 3
            : sectionContent?.cards?.length > 2
              ? 3
              : sectionContent?.cards?.length,
        }}
        spacing="30px"
        mx="auto"
      >
        {sectionContent?.cards?.map((secCon, index) => {
          return (
            <Box
              id="card3"
              key={nanoid()}
              display="flex"
              flexDirection="column"
              mx="auto"
              w={{
                base: '100%',
                sm: '330px',
                // lg: '370px',
                lg: isLeftMenu ? '280px' : '370px',
              }}
              position="relative"
              mb={'20px'}
            >
              {sectionContent?.style === 'idy-card-top-title' && (
                <Box
                  lineHeight={{ md: '26px', base: '28px' }}
                  fontFamily="FedraSansStd-A-medium"
                  fontSize="20px"
                  fontWeight="500"
                  mb="20px"
                  textAlign="center"
                >
                  {secCon?.sessions}
                </Box>
              )}

              {secCon.thumbnail?.url != null &&
                  <Box
                    position="relative"
                    zIndex="1"
                    cursor={secCon.buttonLink ? 'cursor' : 'auto'}
                    marginTop={{sm:"25px", base:"25px"}}
                    //onClick={onOpen}  
                    //onClick={e => refreshPage(e?.target?.href, e)}
                  >
                    <LazyLoadImageComponent
                      src={secCon.thumbnail?.url}
                      alt={secCon.thumbnail?.alt}
                      title={secCon.thumbnail?.title}
                      objectFit="cover"
                      w="100%"
                      minH="210px"
                      maxH={'226.62px'}
                    />
                    <Box
                      w="88.3%"
                      h={{ base: 235, sm: 240, lg: '248.4px' }}
                      objectFit="contain"
                      transform="rotate(-178.76deg)"
                      position="absolute"
                      left="21.65px"
                      background={'#E0D7C8'}
                      outline="1px solid transparent"
                      zIndex="-1"
                      top={{ base: '-15px', sm: '-10px', md: '-10px' }}
                    />
                  {secCon.buttonLink && (
                  <Flex
                    position="relative"
                    top={0}
                    bottom={0}
                    left={0}
                    right={0}
                    justifyContent="center"
                    alignItems="center"
                    //display={vidVis ? 'none' : 'flex'}
                    onClick={onOpen}
                  >
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      w={{ base: '40px', md: '50px' }}
                      h={{ base: '40px', md: '50px' }}
                      rounded={'full'}
                      background={'#FFAE27'}
                      _hover={{
                        boxShadow: ' -4px 14px 22px -5px rgba(0,0,0,0.66)',
                      }}
                      textAlign="center"
                      fontSize={{ base: '15px', md: '15px' }}
                      //onClick={e => setVidVis(!vidVis)}
                      //display={vidVis ? 'none' : 'flex'}
                      color={{lg:'#CE4520', sm:"#000000"}}
                      marginTop={'-240px'}
                    >
                      <TbPlayerPlayFilled  />
                    </Flex>

                    <Modal
                    isOpen={isOpen}
                    onClose={onClose}
                    size={{ base: 'full', md: '6xl' }}
                    isCentered={{ base: false, md: true }}
                  >
                    <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
                    <ModalContent
                      p={0}
                      mx="auto"
                      my={{ base: '0' }}
                      maxW={{ base: '46dvw', xl: '46dvw' }}
                      h={{ base: '50dvh', lg: '50dvh', xl: '50dvh' }}
                    >
                      <ModalCloseButton
                        _hover={{ bg: '#fff', color: '#000' }}
                        _active={{ bg: '#fff', color: '#000' }}
                        _focus={{ bg: '#fff', color: '#000' }}
                        zIndex="20"
                        top={{ base: '-10px', lg: '-24px' }}
                        bg="#fff"
                        color="#000"
                        w={{ base: '35px', md: '48px' }}
                        height={{ base: '35px', md: '48px' }}
                        right={{ base: '-5px', lg: '-15px' }}
                        className="closeButton"
                        rounded="full"
                      />
                      <ModalBody p={0} m="0" w="100%" position="relative" maxH="100%">
                        <Box
                          pos={{ base: 'static', md: 'static' }}
                          left="50%"
                          right="50%"
                          display={{ base: 'flex', md: 'block' }}
                          justifyContent={{ base: 'center' }}
                          height="100%"
                          alignItems={{ base: 'center' }}
                        >
                          <Box
                            bg="#fff"
                            onClick={onClose}
                            w="48px"
                            h="48px"
                            rounded="full"
                            _hover={{ bg: '#fff' }}
                            display={{ base: 'flex', md: 'none' }}
                            justifyContent="center"
                            alignItems="center"
                            pos="absolute"
                            top="-145px"
                            left="-185px"
                            fontFamily="var(--FedraSansStd-Book)"
                            zIndex="10"
                            cursor="pointer"
                            color="black"
                          >
                            x
                          </Box>
                          <Box w="100%" id="msr-vid" bg="#fff" p="14px" h="100%">
                            <YouTube
                              videoId={getEmbedUrl(secCon?.buttonLink)}
                              onReady={onReady}
                              opts={opts}
                              loading="lazy"
                              className="sandhruguLeadership"
                            />
                          </Box>
                        </Box>
                        {/* </Box> */}
                      </ModalBody>
                    </ModalContent>
              </Modal>

                    </Flex>
                  )}
                  </Box>
              }
              <Box m={{ base: '0 13px' }}>
                <Box
                  lineHeight={'25px'}
                  fontFamily="FedraSansStd-book"
                  fontSize="20px"
                  mt="35px"
                  color="#433F3C"
                  fontWeight={'600'}
                  textAlign={pName === "hytt" && "center"}
                >
                  {secCon.title}
                </Box>
                <Box
                  fontFamily="FedraSansStd-book"
                  fontSize="16px"
                  color={'#6D6358'}
                  pt={15}

                >
                  <StructuredTextParser
                    str={render(secCon.description)}
                    region={region}
                    lang={lang}
                    mt="0"
                    className="link-text"
                    textAlign={pName === "hytt" && "center"}
                  />
                </Box>
                {secCon.buttonLink && secCon.buttonText && (
                  <Box>
                    <NextLink
                      onClick={e => refreshPage(e?.target?.href, e)}
                      href={refineUrlDomain(secCon.buttonLink, region, lang)}
                      passHref
                      legacyBehavior>
                      <Link
                        bgColor="transparent"
                        color="#cf4520"
                        mr={{ md: '20px' }}
                        padding="5px 30px"
                        border="1px solid #cf4520"
                        borderRadius="5px"
                        display="inline-block"
                        my={19}
                        fontFamily="FedraSansStd-medium"
                        fontSize="13px"
                        _hover={{
                          color: '#fff',
                          bgColor: '#cf4520',
                          textDecoration: 'none',
                        }}
                        _focus={{
                          color: '#fff',
                          bgColor: '#cf4520',
                          textDecoration: 'none',
                        }}
                        _active={{
                          color: '#fff',
                          bgColor: '#cf4520',
                          textDecoration: 'none',
                        }}
                      >
                        {secCon.buttonText}
                      </Link>
                    </NextLink>
                  </Box>
                )}
              </Box>
              <style global jsx>
                {`
                  #card3 a {
                    color: #cf4824;
                  }
                  #card3 a:hover {
                    color: #ffffff;
                  }
                  .link-text p a {
                    color: #28231e !important;
                    word-break: break-word;
                    border-bottom: 2px solid #cf4824;
                    transition: background-size 0.125s ease-in;
                    background-image: linear-gradient(120deg, #cf4824, #cf4824);
                    background-repeat: no-repeat;
                    background-size: 100% 0;
                    background-position: 0 100%;
                  }

                  .link-text p a:hover {
                    background-color: #cf4824;
                    color: white !important;
                    background-image: linear-gradient(120deg, #cf4824, #cf4824);
                    background-size: 100% 100%;
                    transition: all 0.3s ease-in-out;
                  }
                  .sandhruguLeadership {
                    width: 100%;
                    height: 100%;
                  }
                  .sandhruguLeadership iframe {
                    height: 100%;
                  }
                  .closeButton:hover {
                    background: #ffffff !important;
                    color: black !important;
                  }
                  @media only screen and (max-width: 960px) {
                    .sandhruguLeadership {
                      width: 100%;
                      height: 100%;
                    }
                    .sandhruguLeadership iframe {
                      width: 100%;
                      height: 100%;
                    }
                  }
                `}
              </style>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box >
  );
};

export default CardInfo3V2;
